import React, { useRef } from 'react';
import ReactToPrint from 'react-to-print';

const FormSuccess = ({ isShow, idPendaftaran, formData = {} }) => {
  const { name, last_name, nik, dep_name, dep_address } = formData;
  const contentRef = useRef();
  return (
    isShow && (
      <>
        <div className='row'>
          <div className='col-lg-6'>
            <h1 className='mr-2 d-inline'>Pengisian Berhasil</h1>
            <span className='text-success'>
              <i className='fas fa-check-circle fa-lg' />
            </span>
            <table className='table table-flush mt-2' ref={ contentRef }>
              <tr>
                <td>
                  <b>Kode Pendaftaran</b>
                </td>
                <td>{idPendaftaran}</td>
              </tr>
              <tr>
                <td>
                  <b>Nama</b>
                </td>
                <td>
                  {name} {last_name}
                </td>
              </tr>
              <tr>
                <td>
                  <b>NIK</b>
                </td>
                <td>{nik}</td>
              </tr>
              <tr>
                <td>
                  <b>Nama Perusahaan</b>
                </td>
                <td>{dep_name}</td>
              </tr>
              <tr>
                <td>
                  <b>Alamat Perusahaan</b>
                </td>
                <td>{dep_address}</td>
              </tr>
            </table>
          </div>
        </div>
        <div className='row'>
          <div className='col-lg-6'>
            <ReactToPrint
              trigger={ () => (
                <button
                  className='btn btn-icon btn-primary float-right'
                  type='button'>
                  <span className='btn-inner--icon'>
                    <i className='fas fa-print' />
                  </span>
                  <span className='btn-inner--text'>Cetak</span>
                </button>
              ) }
              content={ () => contentRef.current }
            />
          </div>
        </div>
      </>
    )
  );
};

export default FormSuccess;
